import Api from '@/services/api'

export default {
  addQuestion (questionData) {
    return Api().post('/questions/add', questionData)
  },
  updateQuestion (data) {
    return Api().post('/questions/edit', data)
  },
  addMemberData (data) {
    return Api().post('/members/updateMemberData', data)
  }
}



// WEBPACK FOOTER //
// ./src/services/addService.js